import { DrawControl } from "../controls/DrawControl";

/**
 * Create the drawing toolbar and place it directly above the WKT input box
 * (below the layer-category section). The control manages its own
 * ol/interaction/Draw lifecycle via the passed map, so it is positioned in the
 * DOM manually rather than through map.addControl (which would append it to the
 * map viewport instead of the sidebar).
 *
 * @param {import("ol/Map").default} map
 * @param {HTMLElement} target - the sidebar container (#controls-left)
 * @param {import("../controls/WKTInputControl").WKTInputControl} wktInputControl
 * @returns {DrawControl}
 */
export function addDrawControl(map, target, wktInputControl) {
  const drawControl = new DrawControl({ map, wktInputControl });
  target.insertBefore(drawControl.element, wktInputControl.element);
  return drawControl;
}
